import React, {Component} from 'react'
import './styles.scss';

class SimpleTextInput extends Component {
    constructor(props) {
        super(props);
        let name = "";
        if (props.name) {
            name = props.name;
        } else {
            name = "cbx_" + Math.random().toString(36).substring(7);
        }
        let state = {
            checked: props.checked ? true : false,
            disabled: props.disabled ? true : false,
            name: name,
            value: props.value ? props.value : ""
        };

        this.inputRef = React.createRef();
        this.state = state;
    }

    onChange(evt) {
        //this.setState({value: this.inputRef.value});
    }

    value() {
        return this.inputRef.current.value;
    }

    render() {
        let className = "SimpleTextInput";
        if (this.props.default) className += " default";
        return (
            <div className={className}>
                <span className="label">
                    <label htmlFor={this.state.name}>{this.props.label}</label>
                </span>
                <div>
                <input name={this.state.name}
                       id={this.state.name}
                       type="text"
                       onChange={this.onChange.bind(this)}
                       checked={this.state.checked}
                       defaultValue={this.state.value}
                       ref={this.inputRef}
                       />
                </div>

                
            </div>);
    }
}

export default SimpleTextInput;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/SimpleTextInput/index.js